export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7627.1c8d16a7.jpg";